<template>
  <UiTag class="ground-station-status-badge" :tone="tagTone" v-bind="$attrs" v-on="$listeners"><slot /></UiTag>
</template>

<script>
export default {
  name: 'GroundStationStatusBadge',
  inheritAttrs: false,
  props: {
    tone: {
      type: String,
      default: 'accent',
      validator: value => ['accent', 'muted', 'warning', 'danger'].includes(value)
    }
  },
  computed: {
    tagTone () {
      return { accent: 'primary', muted: 'neutral', warning: 'warning', danger: 'danger' }[this.tone]
    }
  }
}
</script>
